import React from "react";

const ManifestoCreateScreen = () => {
  return (
    <div>
      <h1>Create Manifesto</h1>
    </div>
  );
};

export default ManifestoCreateScreen;
